import { AssetSuggestion, eAssetType } from "../../@types/Asset";

export const suggestions: AssetSuggestion[] = [
  {
    name: "Tesla Inc",
    symbol: "TSLA",
    exchange: "NASDAQ",
    type: eAssetType.STOCK,
    id: "ah77e",
    country_code: 5,
    icon: "TSLA.svg",
    currency_symbol: "USD",
    status: false,
  },
  {
    name: "Apple Inc",
    symbol: "AAPL",
    exchange: "NASDAQ",
    type: eAssetType.STOCK,
    id: "sefn",
    country_code: 5,
    icon: "AAPL.svg",
    currency_symbol: "USD",
    status: false,
  },
  {
    name: "Ambev SA",
    symbol: "ABEV3",
    exchange: "BM&FBovespa",
    type: eAssetType.STOCK,
    id: "anr77",
    country_code: 32,
    icon: "ABEV3.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "Vale SA",
    symbol: "VALE3",
    exchange: "BM&FBovespa",
    type: eAssetType.STOCK,
    id: "annae",
    country_code: 32,
    icon: "VALE3.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "Gerdau SA",
    symbol: "GGBR3",
    exchange: "BM&FBovespa",
    type: eAssetType.STOCK,
    id: "ansnn",
    country_code: 32,
    icon: "GGBR3.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "Bitcoin/BRL",
    symbol: "BTC/BRL",
    exchange: "Mercado",
    type: eAssetType.CRIPTO,
    id: "aftenfo",
    country_code: 241,
    icon: "BTCBRL.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "Ethereum/BTC",
    symbol: "ETH/BTC",
    exchange: "Poloniex",
    type: eAssetType.CRIPTO,
    id: "afafoos",
    country_code: 249,
    icon: "ETHBTC.svg",
    currency_symbol: "BTC",
    status: false,
  },
];

export const walletSuggestions: AssetSuggestion[] = [
  {
    name: "Nvidia Corp.",
    symbol: "NVDA",
    exchange: "NASDAQ",
    type: eAssetType.STOCK,
    id: "se7o",
    country_code: 5,
    icon: "NVDA.svg",
    currency_symbol: "USD",
    status: false,
  },
  {
    name: "Prio SA",
    symbol: "PRIO3",
    exchange: "BM&FBovespa",
    type: eAssetType.STOCK,
    id: "ans7o",
    country_code: 32,
    icon: "PRIO3.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "Bitcoin/BRL",
    symbol: "BTC/BRL",
    exchange: "M. Bitcoin",
    type: eAssetType.CRIPTO,
    id: "aftenfo",
    country_code: 241,
    icon: "BTCBRL.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "CSHG Logística",
    symbol: "HGLG11",
    exchange: "BM&FBovespa",
    type: eAssetType.FIIS,
    id: "7ef7rh",
    country_code: 32,
    icon: "HGLG11.svg",
    currency_symbol: "BRL",
    status: false,
  },
  {
    name: "Kinea Imobiliária",
    symbol: "KNRI11",
    exchange: "BM&FBovespa",
    type: eAssetType.FIIS,
    id: "7ef7rn",
    country_code: 32,
    icon: "KNRI11.svg",
    currency_symbol: "BRL",
    status: false,
  },
];
